import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';
import {
  BaseField,
  BaseFieldProps,
} from '@/components/atoms/BaseField/BaseField';
import { Button } from '@/components/atoms/Button/Button';
import { FieldDef } from '@/components/organisms/EditorFields/fieldHelper';
import { EditorFields } from '@/components/organisms/EditorFields/EditorFields';

export const QuestionTable = ({
  value,
  fieldValue,
  fieldKey,
  onChange,
  isDisabled = false,
  ...props
}: QuestionTableProps) => {
  const newSubFields: { [k: string]: FieldDef } = {};

  fieldValue.field.subfields?.forEach((subField) => {
    newSubFields[subField.id?.toString() || ''] = subField;
  });

  let myValue = value?.[fieldKey] ? JSON.parse(value?.[fieldKey]) : [{}];
  if (myValue.length === 0) {
    myValue = [{}];
  }

  return (
    <>
      <BaseField {...props}>
        <Stack sx={{ width: '100%', gap: sp[16] }}>
          {myValue.map((v: any, i: number) => {
            return (
              <Box
                key={i}
                sx={{
                  border: '1px solid #b2b2b2',
                  borderRadius: '16px',
                  width: '100%',
                  p: `${sp[12]} ${sp[16]}`,
                  gap: sp[16],
                }}
              >
                <Box sx={{ gap: sp[16], width: '100%', py: sp[12] }}>
                  <EditorFields
                    fields={newSubFields}
                    value={v}
                    onChange={(w) => {
                      const newValue = [...myValue];
                      newValue[i] = w;
                      onChange(JSON.stringify(newValue));
                    }}
                    isDisabled={isDisabled}
                  />
                </Box>
                {myValue.length >= 2 && (
                  <Button
                    ariaLabel={'remove more entries'}
                    variant='secondary'
                    isDisabled={isDisabled}
                    onPress={() =>
                      onChange(
                        JSON.stringify([
                          ...myValue.slice(0, i),
                          ...myValue.slice(i + 1),
                        ]),
                      )
                    }
                  >
                    Remove
                  </Button>
                )}
              </Box>
            );
          })}
          {myValue.length === 0 ? (
            <Box
              sx={{
                border: '1px solid #b2b2b2',
                borderRadius: '16px',
                width: '100%',
                p: `${sp[12]} ${sp[16]}`,
              }}
            >
              <Box sx={{ width: '100%', textAlign: 'center' }}>
                {fieldValue.placeholder}
              </Box>
            </Box>
          ) : null}
        </Stack>
      </BaseField>
      <Button
        ariaLabel={'add more entries'}
        isFullWidth
        variant='secondary'
        onPress={() => onChange(JSON.stringify([...myValue, {}]))}
        iconLeft={'plus'}
        isDisabled={isDisabled}
      >
        Add another
      </Button>
    </>
  );
};

interface QuestionTableProps extends BaseFieldProps {
  value?: any;
  fieldValue: FieldDef;
  fieldKey: string;
  onChange: (newVal: string) => void;
}

QuestionTable.displayName = 'QuestionTable';

export default QuestionTable;
